import React from 'react';
import { motion } from 'framer-motion';

import OnboardingSplitLayout from 'features/courier-onboarding/components/OnboardingSplitLayout';
import PremiumStepper from 'shared/components/PremiumStepper';

interface WizardShellProps {
  title: string;
  subtitle?: string;
  currentStep: number;
  totalSteps: number;
  stepKeys?: string[];
  maxReached?: number;
  onStepSelect?: (step: number) => void;
  children: React.ReactNode;
}

const WizardShell: React.FC<WizardShellProps> = ({
  title,
  subtitle,
  currentStep,
  totalSteps,
  stepKeys,
  maxReached,
  onStepSelect,
  children,
}) => {
  const progressBar =
    stepKeys && stepKeys.length > 0 ? (
      <PremiumStepper
        current={currentStep}
        maxReached={maxReached ?? currentStep}
        total={totalSteps}
        trackFromStep={1}
        trackToStep={stepKeys.length}
        stepKeys={stepKeys}
        onStepSelect={onStepSelect}
      />
    ) : undefined;

  return (
    <OnboardingSplitLayout progressBar={progressBar} scrollKey={currentStep}>
      <motion.div
        key={currentStep}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.2 }}
      >
        {title ? (
          <h1 className="text-[clamp(1.5rem,5vw,1.875rem)] font-extrabold leading-tight tracking-tight text-gray-900">
            {title}
          </h1>
        ) : null}
        {subtitle ? (
          <p className="mt-2 max-w-2xl text-base leading-relaxed text-gray-600">
            {subtitle}
          </p>
        ) : null}
        <div className={title || subtitle ? 'mt-6' : ''}>{children}</div>
      </motion.div>
    </OnboardingSplitLayout>
  );
};

export default WizardShell;
